/* eslint-disable import/prefer-default-export */
export function loadElasticApm(config: Record<string, any>) {
  const script = document.createElement('script');
  script.src =
    'https://unpkg.com/@elastic/apm-rum@5.12.0/dist/bundles/elastic-apm-rum.umd.min.js';
  script.async = true;
  script.onload = () => {
    if ((window as any).elasticApm) {
      (window as any).elasticApm.init(config);
    }
  };
  document.head.appendChild(script);
}
